import styled from 'styled-components'
import {
  communicationContentWrapperCss,
  communicationRootCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const GenderCommunicationStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div`
    ${communicationContentWrapperCss}
    align-items: center;
    gap: 24px;
  `,

  Title: styled.h1`
    font-family: 'Poppins', sans-serif;
    font-size: 21px;
    font-weight: 600;
    line-height: 1.5;
    text-align: center;
    color: ${COLORS.BLACK};
  `,

  Options: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin: auto 0;
  `,

  Card: styled.button<{ $isSelected?: boolean }>`
    width: 164px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 24px 16px;
    background-color: ${({ $isSelected }) =>
      $isSelected ? '#ebf3ff' : COLORS.WHITE};
    border: 2px solid
      ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#eaeaed')};
    border-radius: 16px;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  `,

  CardImage: styled.img`
    height: 76px;
    width: auto;
  `,

  CardLabel: styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.3;
    text-align: center;
    color: ${COLORS.BLACK};
  `,
}
